module.exports = __webpack_public_path__ + "static/YuriiDrozd-1fcb61efa194f8b450f852bbd25083ee.jpeg";